var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileSettingsHoverIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comp-drawer-settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1573",
    "data-name": "Rectangle 1573",
    width: 24,
    height: 24,
    rx: 4,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "settings_FILL0_wght400_GRAD0_opsz48_3_",
    "data-name": "settings_FILL0_wght400_GRAD0_opsz48 (3)",
    d: "M11.7,24l-.5-3.15a6.7,6.7,0,0,1-1-.475,6.871,6.871,0,0,1-.925-.625L6.325,21.1,4,17l2.7-1.975a2.972,2.972,0,0,1-.062-.512q-.012-.287-.012-.512t.012-.513a2.972,2.972,0,0,1,.063-.512L4,11,6.325,6.9l2.95,1.35a6.871,6.871,0,0,1,.925-.625,5.173,5.173,0,0,1,1-.45L11.7,4h4.6l.5,3.15a8.105,8.105,0,0,1,1.013.462,4.3,4.3,0,0,1,.913.637l2.95-1.35L24,11l-2.7,1.925a3.523,3.523,0,0,1,.062.538q.012.288.013.538t-.013.525a3.481,3.481,0,0,1-.062.525L24,17l-2.325,4.1-2.95-1.35a8.293,8.293,0,0,1-.913.638,4.357,4.357,0,0,1-1.013.463L16.3,24ZM14,17.25A3.244,3.244,0,0,0,17.25,14,3.244,3.244,0,0,0,14,10.75,3.244,3.244,0,0,0,10.75,14,3.244,3.244,0,0,0,14,17.25Zm0-1.5a1.75,1.75,0,1,1,1.237-.512A1.686,1.686,0,0,1,14,15.75ZM14,14Zm-1.1,8.5h2.2l.35-2.8a5.9,5.9,0,0,0,1.562-.625A6.407,6.407,0,0,0,18.35,18.05L21,19.2l1-1.8-2.35-1.725q.1-.425.163-.837A5.583,5.583,0,0,0,19.875,14a6.953,6.953,0,0,0-.05-.838,5.172,5.172,0,0,0-.175-.837L22,10.6,21,8.8,18.35,9.95a5.573,5.573,0,0,0-1.3-1.088,4.217,4.217,0,0,0-1.6-.562L15.1,5.5H12.9l-.35,2.8a5.3,5.3,0,0,0-1.588.6A5.514,5.514,0,0,0,9.65,9.95L7,8.8,6,10.6l2.35,1.725q-.1.425-.162.838a5.642,5.642,0,0,0,0,1.675q.062.412.162.837L6,17.4l1,1.8,2.65-1.15a6.408,6.408,0,0,0,1.338,1.025,5.9,5.9,0,0,0,1.563.625Z",
    transform: "translate(-2 -2)",
    fill: "#227c9d",
    opacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSettingsHoverIcon);
export default __webpack_public_path__ + "static/media/Profile-settings-hover-icon.51a45c331ebcc2a15305aadc986cedc5.svg";
export { ForwardRef as ReactComponent };